import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import firebaseApp from "firebase";
import vuetify from "./plugins/vuetify";

// *** Interfaces
import { userData } from "./interfaces/user.interface";
import { Workout } from "./interfaces/workout.interface";
import { getNowInUnix } from "./interfaces/time.interface";
import { WorkoutHistoryDateRanges } from "./interfaces/history.interface";

firebaseApp.initializeApp({
  apiKey: "AIzaSyDZmMZxHbQTI4dYZgr5Ieoql0YCBUEjY4Q",
  authDomain: "squat-watch.firebaseapp.com",
  projectId: "squat-watch",
  storageBucket: "squat-watch.appspot.com",
  messagingSenderId: "675094569621",
  appId: "1:675094569621:web:9131c523fd56cff096b19c",
});

export default firebaseApp;

Vue.config.productionTip = false;

let app: any = null;

firebaseApp.auth().onAuthStateChanged(async (user) => {
  if (user) {
    console.log("There is a user signed in");
    console.log("User uid:", user.uid);
    store.commit("userStore/setUserUID", user.uid);

    // Get userData if local storage data is out of date else use localStorage and set it
    const userDataDifferenceInSeconds: number =
      getNowInUnix() - Number(localStorage.getItem("userDataLastUpdate"));

    if (userDataDifferenceInSeconds < 300) {
      const userDataTemp: string | null = localStorage.getItem("userData");
      if (userDataTemp !== null) {
        const userData: userData = JSON.parse(userDataTemp);
        store.commit("workoutStore/setCurrentWorkout", userData.currentWorkout);
        store.commit("userStore/setUserData", userData);
        store.commit(
          "templateStore/updateUsersTemplates",
          userData.workoutTemplates
        );
        console.log("Set userData with localstorage");
      }
    } else {
      console.log("Local storage is older than 5 minutes, getting user data.");
      await firebaseApp
        .firestore()
        .collection("users")
        .doc(user.uid)
        .get()
        .then(async (res) => {
          if (res.exists) {
            const data: any = res.data();
            const userData: userData = {
              userName: data.userName,
              customExercises: data.customExercises,
              workoutTemplates: data.workoutTemplates,
              favoriteExercises: data.favoriteExercises,
              visibility: data.visibility,
              dateJoined: data.dateJoined,
              currentWorkout: data.currentWorkout ? data.currentWorkout : null,
              age: data.age ? data.age : undefined,
              weight: data.weight ? data.weight : undefined,
              profileImgUrl: data.profileImgUrl
                ? data.profileImgUrl
                : undefined,
              description: data.description ? data.description : undefined,
            };

            if (!userData.age) delete userData.age;
            if (!userData.weight) delete userData.weight;
            if (!userData.description) delete userData.description;
            if (!userData.profileImgUrl) delete userData.profileImgUrl;

            store.commit(
              "workoutStore/setCurrentWorkout",
              userData.currentWorkout
            );
            store.commit("userStore/setUserData", userData);
            store.commit(
              "templateStore/updateUsersTemplates",
              userData.workoutTemplates
            );

            localStorage.setItem("userData", JSON.stringify(userData));
            localStorage.setItem("userDataLastUpdate", String(getNowInUnix()));
          } else {
            console.log("USER DOES NOT HAVE DATA");

            // Todo: add logic to
          }
        })
        .catch((err) => {
          console.error("Could not get users data");
          console.error(err);
        });
    }

    // Get historyData if local storage data is out of date else use localStorage and set it
    const workoutHistoryDifferenceInSeconds: number =
      getNowInUnix() - Number(localStorage.getItem("workoutHistoryUpdate"));

    if (workoutHistoryDifferenceInSeconds < 300) {
      console.log("Set Workout History with Local Storage");
      const workoutHistoryTemp: string | null = localStorage.getItem(
        "workoutHistory"
      );
      if (workoutHistoryTemp !== null) {
        const workoutHistory: Workout[] = JSON.parse(workoutHistoryTemp);
        store.commit("historyStore/updateWorkoutHistory", workoutHistory);
      }
    } else {
      // Get One Month Of Workout History
      const oneMonthDateRange: WorkoutHistoryDateRanges = {
        recentDate: getNowInUnix(),
        oldDate: getNowInUnix() - 2629800, // 2629800 = 1 month in seconds
      };

      await store
        .dispatch("historyStore/getWorkoutHistory", oneMonthDateRange)
        .then((workoutHistory) => {
          store.commit("historyStore/updateWorkoutHistory", workoutHistory);
          localStorage.setItem(
            "workoutHistory",
            JSON.stringify(workoutHistory)
          );
          localStorage.setItem("workoutHistoryUpdate", String(getNowInUnix()));
        })
        .catch((err) => {
          console.error(err);
        });
    }
  } else {
    console.log("USER IS NOT SIGNED IN WITH FIREBASE ACCOUNT");
    store.commit("userStore/setUserUID", null);
    store.commit("userStore/setUserData", null);
    localStorage.clear();
  }

  if (!app) {
    app = new Vue({
      router,
      store,
      vuetify,
      render: (h) => h(App),
    }).$mount("#app");
  }
});
